import React from 'react';
import PropTypes from 'prop-types';
import ConfigProvider from '../config-provider';
import { obj } from '../util';

class Cover extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    className: PropTypes.string,
    img: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    extra: PropTypes.node,
    description: PropTypes.node,
    tag: PropTypes.string,
    link: PropTypes.string.isRequired,
    target: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
  }

  static defaultProps = {
    prefix: 'next-',
    target: '_self',
    onMouseEnter: () => {},
    onMouseLeave: () => {},
  }

  render() {
    const {
      prefix,
      className,
      img,
      title,
      extra,
      description,
      tag,
      link,
      target,
      onMouseEnter,
      onMouseLeave,
      ...others
    } = this.props;
    return (
      <a
        href={link}
        target={target}
        className={`${prefix}cover`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...obj.pickAttrs(others)}
        style={{
          ...(others.style ? others.style : {}),
          backgroundImage: `url(${img})`,
        }}
      >
        <div className={`${prefix}cover-inner`}>
          <div className={`${prefix}cover-header`}>
            <div className={`${prefix}cover-header-title`}>{title}</div>
            {
              extra ?
                <div className={`${prefix}cover-header-extra`}>
                  {extra}
                </div> : null
            }
          </div>
          {
            description ?
              <div className={`${prefix}cover-description`}>{description}</div> : null
          }
          {
            tag ?
              <div className={`${prefix}cover-tag`}>{tag}</div> : null
          }
        </div>
      </a>
    );
  }
}

const Configured = ConfigProvider.config(Cover);
Configured.displayName = 'Cover';

export default Configured;
